import Breadcrumb from './Breadcrumb'
import BreadcrumbItem from './BreadcrumbItem'

Breadcrumb.Item = BreadcrumbItem
export default Breadcrumb



// WEBPACK FOOTER //
// ./components/breadcrumb/index.js